import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import './MultiSignalsLoadingFull.scss';

// Import modern icons
import { 
  Loader2, 
  Bot, 
  TrendingUp, 
  Settings,
  Activity,
  RefreshCw
} from 'lucide-react';

const MultiSignalsLoadingFull = (props) => {
  const { isLoading, loadingText } = props.fullLoading;
  const [dots, setDots] = useState('');
  const [progress, setProgress] = useState(0);

  // Animated dots effect
  useEffect(() => {
    if (!isLoading) return;

    const interval = setInterval(() => {
      setDots(prev => {
        if (prev === '...') return '';
        return prev + '.';
      });
    }, 500);

    return () => clearInterval(interval);
  }, [isLoading]);

  // Simulated progress for better UX
  useEffect(() => {
    if (!isLoading) {
      setProgress(0);
      return;
    }

    setProgress(0);
    const progressInterval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 90) return prev;
        return prev + Math.random() * 10;
      });
    }, 200);

    return () => clearInterval(progressInterval);
  }, [isLoading]);

  // Get appropriate icon based on loading text
  const getLoadingIcon = () => {
    const text = loadingText?.toLowerCase() || '';
    
    if (text.includes('strategy') || text.includes('bot')) {
      return <Bot size={24} className="loading-icon" />;
    } else if (text.includes('trading') || text.includes('market')) {
      return <TrendingUp size={24} className="loading-icon" />;
    } else if (text.includes('setting') || text.includes('config')) {
      return <Settings size={24} className="loading-icon" />;
    } else if (text.includes('activity') || text.includes('data')) {
      return <Activity size={24} className="loading-icon" />;
    } else {
      return <RefreshCw size={24} className="loading-icon spinning" />;
    }
  };

  if (!isLoading) {
    return <></>;
  }

  return (
    <div className="modern-loading-overlay">
      <div className="loading-backdrop" />
      
      <div className="modern-loading-container">
        <div className="loading-card">
          {/* Loading Icon */}
          <div className="loading-icon-wrapper">
            {getLoadingIcon()}
            <div className="icon-pulse-ring" />
          </div>

          {/* Loading Content */}
          <div className="loading-content">
            <h3 className="loading-title">
              {loadingText || 'Loading'}{dots}
            </h3>
            <p className="loading-subtitle">
              Please wait while we process your request
            </p>
          </div>

          {/* Progress Bar */}
          <div className="loading-progress">
            <div className="progress-track">
              <div 
                className="progress-fill"
                style={{ width: `${progress}%` }}
              />
            </div>
            <div className="progress-text">
              {Math.round(progress)}%
            </div>
          </div>

          {/* Animated Spinner */}
          <div className="loading-spinner">
            <Loader2 size={32} className="spinner-icon" />
          </div>
        </div>

        {/* Background Animation */}
        <div className="background-animation">
          <div className="floating-circle circle-1" />
          <div className="floating-circle circle-2" />
          <div className="floating-circle circle-3" />
          <div className="floating-circle circle-4" />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    fullLoading: state.loadingReducer.fullLoading
  };
};

export default connect(mapStateToProps)(MultiSignalsLoadingFull);